(function () {
  'use strict';

  /* ===== Image Gallery ===== */
  const main = document.querySelector('[data-ds-main-image]');
  const slider = document.querySelector('[data-ds-slider]');
  const dotsWrap = document.querySelector('[data-ds-dots]');
  const thumbsWrap = document.querySelector('[data-ds-thumbs]');

  // Re-queried live each time rather than cached — rebuildGallery() replaces these nodes
  // whenever the selected variant has its own dedicated photo set (data-variant-gallery-id).
  const getSlides = () => document.querySelectorAll('[data-ds-image-slide]');
  const getThumbs = () => document.querySelectorAll('[data-ds-thumb]');
  const getDots = () => document.querySelectorAll('[data-ds-dot]');

  function showSlide(idx, scroll = true) {
    getSlides().forEach(s => s.classList.toggle('is-active', parseInt(s.dataset.index) === idx));
    getThumbs().forEach(t => t.classList.toggle('is-active', parseInt(t.dataset.index) === idx));
    getDots().forEach(d => d.classList.toggle('is-active', parseInt(d.dataset.index) === idx));
    // On mobile the gallery is a real horizontal-scroll strip (see ds-product.css) —
    // toggling is-active alone has no visual effect there, only scrollTo does.
    if (scroll && slider && slider.clientWidth > 0) {
      slider.scrollTo({ left: idx * slider.clientWidth, behavior: 'smooth' });
    }
  }

  function bindGalleryClicks() {
    getThumbs().forEach(t => {
      t.onclick = () => showSlide(parseInt(t.dataset.index));
    });
    getDots().forEach(d => {
      d.onclick = () => showSlide(parseInt(d.dataset.index));
    });
  }
  bindGalleryClicks();

  if (slider) {
    let scrollTimer;
    slider.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        if (slider.clientWidth === 0 || slider.scrollWidth <= slider.clientWidth) return;
        showSlide(Math.round(slider.scrollLeft / slider.clientWidth), false);
      }, 80);
    }, { passive: true });
  }

  // Replaces the whole gallery with a variant's own dedicated photo set — used because a
  // product's shared image pool otherwise mixes every merged variant's photos together.
  function rebuildGallery(urls, altText) {
    if (!slider || !urls || !urls.length) return;
    const alt = (altText || '').replace(/"/g, '&quot;');
    slider.innerHTML = urls.map((url, i) => `
      <img src="${url}&width=800"
           srcset="${url}&width=600 600w, ${url}&width=1000 1000w, ${url}&width=1400 1400w"
           sizes="(max-width: 900px) 100vw, 600px"
           alt="${alt}"
           loading="${i === 0 ? 'eager' : 'lazy'}"
           data-ds-image-slide
           data-index="${i}"
           class="${i === 0 ? 'is-active' : ''}"
           width="800" height="800">
    `).join('');

    const multi = urls.length > 1;
    if (dotsWrap) {
      dotsWrap.hidden = !multi;
      dotsWrap.innerHTML = multi
        ? urls.map((_, i) => `<button type="button" class="ds-pdp__dot ${i === 0 ? 'is-active' : ''}" data-ds-dot data-index="${i}" aria-label="Go to image ${i + 1}"></button>`).join('')
        : '';
    }
    if (thumbsWrap) {
      thumbsWrap.hidden = !multi;
      thumbsWrap.innerHTML = multi
        ? urls.map((url, i) => `
            <button type="button" class="ds-pdp__thumb ${i === 0 ? 'is-active' : ''}" data-ds-thumb data-index="${i}" aria-label="View image ${i + 1}">
              <img src="${url}&width=160" alt="" loading="lazy" width="80" height="80">
            </button>
          `).join('')
        : '';
    }

    bindGalleryClicks();
    if (slider.scrollTo) slider.scrollTo({ left: 0, behavior: 'instant' });
  }

  /* ===== Quantity Stepper ===== */
  const qtyInput = document.querySelector('[data-ds-qty]');
  const qtyDown = document.querySelector('[data-ds-qty-down]');
  const qtyUp = document.querySelector('[data-ds-qty-up]');
  if (qtyDown && qtyInput) qtyDown.addEventListener('click', () => {
    const v = Math.max(1, parseInt(qtyInput.value) - 1);
    qtyInput.value = v;
  });
  if (qtyUp && qtyInput) qtyUp.addEventListener('click', () => {
    qtyInput.value = parseInt(qtyInput.value) + 1;
  });

  /* ===== Variant Picker ===== */
  const optionPills = document.querySelectorAll('[data-ds-option]');
  const variantSelect = document.querySelector('[data-ds-variant-select]');

  function getSelectedOptions() {
    const selected = {};
    document.querySelectorAll('.ds-pdp__option-pill.is-active').forEach(p => {
      selected[p.dataset.optionPosition] = p.dataset.optionValue;
    });
    return selected;
  }

  // Options are shared across the whole product (e.g. "Color" also applies to editions that
  // don't have real per-color variants), so not every pill combination is a real, buyable
  // variant. Position 1 (Edition) is always independently real — every edition is its own
  // purchasable product line, so its pills are never hidden. Later positions (Color) depend
  // on the earlier ones, so only THOSE get filtered down to what actually exists for the
  // currently selected Edition.
  const validCombos = variantSelect
    ? Array.from(variantSelect.options).map(opt => opt.text.split('/').map(s => s.trim()))
    : [];

  function comboExistsForPosition(pos, val) {
    const posNum = parseInt(pos, 10);
    const selected = getSelectedOptions();
    const constraintPositions = Object.keys(selected).filter(p => parseInt(p, 10) < posNum);
    const check = Object.assign({}, selected, { [pos]: val });
    return validCombos.some(combo =>
      constraintPositions.concat(String(pos)).every(p => combo[parseInt(p, 10) - 1] === check[p])
    );
  }

  function selectPill(pill) {
    const pos = pill.dataset.optionPosition;
    document.querySelectorAll(`[data-option-position="${pos}"]`).forEach(p => p.classList.remove('is-active'));
    pill.classList.add('is-active');
    const valueEl = document.querySelector(`[data-option-value="${pos}"]`);
    if (valueEl) valueEl.textContent = pill.dataset.optionValue;
  }

  function updatePillAvailability() {
    optionPills.forEach(pill => {
      const pos = pill.dataset.optionPosition;
      pill.hidden = parseInt(pos, 10) === 1 ? false : !comboExistsForPosition(pos, pill.dataset.optionValue);
    });

    // A position with only one real choice for the current selection isn't a choice at all —
    // hide the whole row (label + pills) rather than show a single lonely pill.
    document.querySelectorAll('[data-ds-option-block]').forEach(block => {
      const pos = block.dataset.optionPosition;
      if (parseInt(pos, 10) === 1) { block.hidden = false; return; }
      const visibleCount = document.querySelectorAll(`[data-option-position="${pos}"][data-ds-option]:not([hidden])`).length;
      block.hidden = visibleCount <= 1;
    });
  }

 function updateVariant() {
  if (!variantSelect) return;

  const selected = getSelectedOptions();
  const options = Array.from(variantSelect.options);

  const match = options.find(opt => {
    return (
      (!selected["1"] || opt.text.includes(selected["1"])) &&
      (!selected["2"] || opt.text.includes(selected["2"])) &&
      (!selected["3"] || opt.text.includes(selected["3"]))
    );
  });

  if (!match) {
    console.warn('No variant match found');
    return;
  }

  variantSelect.value = match.value;

  const galleryScript = document.querySelector(`[data-variant-gallery-id="${match.value}"]`);
  let usedGalleryRebuild = false;
  if (galleryScript) {
    try {
      const urls = JSON.parse(galleryScript.textContent);
      if (urls && urls.length) {
        rebuildGallery(urls, match.text || '');
        usedGalleryRebuild = true;
      }
    } catch (e) {
      console.error('Variant gallery parse error', e);
    }
  }
  if (!usedGalleryRebuild) {
    const mediaId = match.dataset.mediaId;
    if (mediaId) {
      const slideIdx = Array.from(getSlides()).findIndex(s => s.dataset.mediaId === mediaId);
      if (slideIdx > -1) showSlide(slideIdx);
    }
  }

  const descEl = document.querySelector('[data-ds-description]');
  const descScript = document.querySelector(`[data-variant-description-id="${match.value}"]`);
  if (descEl && descScript) {
    try {
      descEl.innerHTML = JSON.parse(descScript.textContent);
    } catch (e) {
      console.error('Variant description parse error', e);
    }
  }

  const price = parseInt(match.dataset.price);
  const available = match.dataset.available === 'true';

  const priceEl = document.querySelector('[data-ds-price-display]');
  if (priceEl) priceEl.textContent = formatMoney(price);

  const stockWrap = document.querySelector('[data-ds-stock]');
  if (stockWrap) {
    const qty = parseInt(match.dataset.inventory, 10) || 0;
    const managed = match.dataset.managed === 'true';
    if (!available) {
      stockWrap.innerHTML = `
        <div class="ds-pdp__stock ds-pdp__stock--out">
          <span class="ds-pdp__stock-dot"></span>
          Currently out of stock
        </div>`;
    } else if (managed && qty > 0 && qty <= 20) {
      stockWrap.innerHTML = `
        <div class="ds-pdp__stock ds-pdp__stock--low">
          <span class="ds-pdp__stock-dot"></span>
          Only <strong>${qty}</strong> left in stock — order soon
        </div>`;
    } else {
      stockWrap.innerHTML = `
        <div class="ds-pdp__stock ds-pdp__stock--in">
          <span class="ds-pdp__stock-dot"></span>
          In stock — ready to dispatch from Birmingham
        </div>`;
    }
  }

  const atcBtn = document.querySelector('[data-ds-atc]');
  const atcText = document.querySelector('.ds-pdp__atc-text');

  if (atcBtn) {
    atcBtn.disabled = !available;
    if (atcText) {
      atcText.textContent = available
        ? `Add to Cart — ${formatMoney(price)}`
        : 'Sold Out';
    }
  }
}

  
  optionPills.forEach(pill => {
    pill.addEventListener('click', () => {
      const pos = parseInt(pill.dataset.optionPosition, 10);
      selectPill(pill);

      // Only LATER positions (e.g. Color) can become invalid from an earlier one (Edition)
      // changing — never the reverse. Snap any now-invalid later position to its first
      // valid choice for the new selection.
      const laterPositions = new Set(
        Array.from(optionPills, p => p.dataset.optionPosition).filter(p => parseInt(p, 10) > pos)
      );
      laterPositions.forEach(laterPos => {
        const activePill = document.querySelector(`[data-option-position="${laterPos}"].is-active`);
        if (activePill && comboExistsForPosition(laterPos, activePill.dataset.optionValue)) return;
        const candidate = Array.from(document.querySelectorAll(`[data-option-position="${laterPos}"]`))
          .find(cp => comboExistsForPosition(laterPos, cp.dataset.optionValue));
        if (candidate) selectPill(candidate);
      });

      updatePillAvailability();
      updateVariant();
    });
  });

  updatePillAvailability();
  updateVariant();

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  /* ===== Tabs ===== */
  const tabBtns = document.querySelectorAll('[data-ds-tab-trigger]');
  const tabPanels = document.querySelectorAll('[data-ds-tab-panel]');
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.dsTabTrigger;
      tabBtns.forEach(b => b.classList.toggle('is-active', b === btn));
      tabPanels.forEach(p => p.classList.toggle('is-active', p.dataset.dsTabPanel === target));
    });
  });

  /* ===== Mobile Accordion (tabs collapse to accordion <=640px) ===== */
  document.querySelectorAll('[data-ds-acc]').forEach(btn => {
    btn.addEventListener('click', () => {
      const panel = document.querySelector(`[data-ds-tab-panel="${btn.dataset.dsAcc}"]`);
      const open = btn.classList.toggle('is-open');
      if (panel) panel.classList.toggle('is-open', open);
    });
  });

  /* ===== AJAX Add to Cart ===== */
  const form = document.getElementById('ds-product-form');
  const atcBtn = document.querySelector('[data-ds-atc]');

  if (form && atcBtn) {
    form.addEventListener('submit', function (e) {
      // Allow Buy Now (name="checkout") to submit normally
      if (e.submitter && e.submitter.name === 'checkout') return;

      e.preventDefault();
      const formData = new FormData(form);
      const originalText = atcBtn.querySelector('.ds-pdp__atc-text').textContent;
      atcBtn.dataset.loading = 'true';
      atcBtn.querySelector('.ds-pdp__atc-text').textContent = 'Adding…';

      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity') || 1, 10);

     fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  body: JSON.stringify({
    items: [{ id: parseInt(variantId, 10), quantity }],
    sections: 'cart-drawer,cart-icon-bubble',
    sections_url: window.location.pathname
  })
})
.then(async (r) => {
  const text = await r.text();
  let data;
  try {
    data = JSON.parse(text);
  } catch(e) {
    console.error('Non-JSON response from /cart/add.js:', text.substring(0, 200));
    throw new Error('Cart error — unexpected server response');
  }
  if (!r.ok) throw new Error(data.description || 'Add to cart failed');
  return data;
})
.then(data => {
  atcBtn.dataset.loading = 'false';
  atcBtn.dataset.added = 'true';
  atcBtn.querySelector('.ds-pdp__atc-text').textContent = '✓ Added to Cart';

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && data.sections) {
    cartDrawer.renderContents({ id: variantId, sections: data.sections });
  }

  setTimeout(() => {
    atcBtn.dataset.added = 'false';
    atcBtn.querySelector('.ds-pdp__atc-text').textContent = originalText;
    atcBtn.disabled = false;
  }, 2500);
})
.catch(err => {
  atcBtn.dataset.loading = 'false';
  atcBtn.disabled = false;
  atcBtn.querySelector('.ds-pdp__atc-text').textContent = originalText;
  console.error('[DS ATC]', err.message);
  alert(err.message);
});
    });
  }


  /* ===== Sticky Mobile Bar ===== */
  const stickyBar = document.querySelector('[data-ds-sticky-bar]');
  const stickyAtc = document.querySelector('[data-ds-sticky-atc]');
  const mainAtc = document.querySelector('[data-ds-atc]');

   if (stickyBar && mainAtc) {
    let hasIntersected = false;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) hasIntersected = true;
        if (hasIntersected) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        }
      });
    }, { threshold: 0 });
    observer.observe(mainAtc);
  }
  if (stickyAtc && mainAtc) {
    stickyAtc.addEventListener('click', () => {
      mainAtc.click();
      window.scrollTo({ top: mainAtc.getBoundingClientRect().top + window.scrollY - 200, behavior: 'smooth' });
    });
  }
  /* ===== Initialize variant state on page load ===== */
(function initVariant() {
  const variantSelectEl = document.querySelector('[data-ds-variant-select]');
  if (!variantSelectEl) return;

  const selected = variantSelectEl.options[variantSelectEl.selectedIndex];
  if (!selected) return;

  const price     = parseInt(selected.dataset.price) || 0;
  const available = selected.dataset.available === 'true';
  const atcText   = document.querySelector('.ds-pdp__atc-text');
  const atcBtn    = document.querySelector('[data-ds-atc]');

  if (atcBtn) {
    atcBtn.disabled = !available;
    if (atcText) {
      atcText.textContent = available
        ? 'Add to Cart — £' + (price / 100).toFixed(2)
        : 'Sold Out';
    }
  }
})();

  /* ===== Frequently Bought Together ===== */
  /* Widget is rendered server-side from precomputed metafields (see ds-product.liquid) —
     this just wires up the checkbox totals + combined add-to-cart. */
  (function initFBT() {
    const wrap = document.querySelector('[data-ds-fbt]');
    if (!wrap) return;

    const row = wrap.querySelector('[data-ds-fbt-row]');
    const totalEl = wrap.querySelector('[data-ds-fbt-total]');
    const totalOriginalEl = wrap.querySelector('[data-ds-fbt-total-original]');
    const savingsEl = wrap.querySelector('[data-ds-fbt-savings]');
    const addBtn = wrap.querySelector('[data-ds-fbt-add]');
    const checkboxes = row.querySelectorAll('[data-ds-fbt-check]');
    const discountPct = parseInt(wrap.dataset.dsFbtDiscountPct || '0', 10);

    function updateTotal() {
      const checked = Array.from(row.querySelectorAll('[data-ds-fbt-check]:checked'));
      const total = checked.reduce((sum, cb) => sum + parseInt(cb.dataset.price, 10), 0);

      const requiredCbs = Array.from(row.querySelectorAll('[data-ds-fbt-required]'));
      const allRequiredChecked = requiredCbs.length > 0 && requiredCbs.every(cb => cb.checked);

      if (discountPct > 0 && allRequiredChecked) {
        const discounted = Math.round(total * (100 - discountPct) / 100);
        totalOriginalEl.textContent = formatMoney(total);
        totalOriginalEl.hidden = false;
        totalEl.textContent = formatMoney(discounted);
        savingsEl.textContent = 'You save ' + formatMoney(total - discounted);
        savingsEl.hidden = false;
      } else {
        totalOriginalEl.hidden = true;
        totalEl.textContent = formatMoney(total);
        savingsEl.hidden = true;
      }

      addBtn.textContent = 'Add ' + checked.length + ' Item' + (checked.length !== 1 ? 's' : '') + ' to Cart';
      addBtn.disabled = checked.length < 2;
    }

    checkboxes.forEach(cb => cb.addEventListener('change', updateTotal));
    updateTotal();

    addBtn.addEventListener('click', () => {
      const checked = Array.from(row.querySelectorAll('[data-ds-fbt-check]:checked'));
      const cartItems = checked.map(cb => ({ id: parseInt(cb.dataset.variantId, 10), quantity: 1 }));
      if (cartItems.length < 2) return;

      const originalText = addBtn.textContent;
      addBtn.dataset.loading = 'true';
      addBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: cartItems, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      })
      .then(r => r.json())
      .then(data => {
        addBtn.dataset.loading = 'false';
        addBtn.textContent = '✓ Added';
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && data.sections) cartDrawer.renderContents({ sections: data.sections });
        setTimeout(() => { addBtn.textContent = originalText; }, 2000);
      })
      .catch(() => {
        addBtn.dataset.loading = 'false';
        addBtn.textContent = originalText;
      });
    });
  })();
})();